import getSeatingMapObjectParent from '%paysera_seat_selection/js/seatSelection/services/getSeatingMapObjectParent';
import { OBJECT_TYPE_ROW } from '%paysera_seat_selection/js/seatSelection/config/constants';

function getSeatUpperParent(seat) {
    const parent = getSeatingMapObjectParent(seat);

    if (parent?.objectType === OBJECT_TYPE_ROW) {
        return parent.sector;
    }

    return parent;
}

export default getSeatUpperParent;
